import React from "react";
import {
  Table,
  Button as But,
  Modal,
  Spin,
  notification,
  Form,
  Row,
  Col,
  DatePicker,
} from "antd";

import Button from "../components/ReportFormGenerator/Button/Button";
import TextBox from "../components/ReportFormGenerator/TextBox/TextBox";
import liracrypt from "../components/Liracrypt/liracrypt";

function PasswordReset({ setPageHeader }) {
  setPageHeader("Reset Password");

  const [form1] = Form.useForm();

  const [loading, setLoading] = React.useState(false);

  const onFinish = (values) => {
    setLoading(true);
    liracrypt
      .post("/resetpassword", values)
      .then((res, req) => {
        notification.success({ message: "Password Reset Successful" });
        setLoading(false);
      })
      .catch((err) => {
        notification.error({ message: "Invalid Credentials" });
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="FormGEn"
            form={form1}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row justify="center">
              <Col span={12}>
                <TextBox
                  form={form1}
                  type="input"
                  name="opass"
                  label="Old Password"
                  required={true}
                  errorMessage="Please Enter Old Password"
                  password={true}
                  onChange={(e) =>
                    form1.setFieldsValue({ opass: e.target.value })
                  }
                />
              </Col>
            </Row>
            <Row justify="center">
              <Col span={12}>
                <TextBox
                  form={form1}
                  type="input"
                  name="npass"
                  label="New Password"
                  required={true}
                  errorMessage="Please Enter New Password"
                  onChange={(e) =>
                    form1.setFieldsValue({ npass: e.target.value })
                  }
                  password={true}
                />
              </Col>
            </Row>

            <Row gutter={24} justify="center">
              <Col span={24}>
                <Button
                  marginLeft={"300px"}
                  loading={loading}
                  form={form1}
                  cancelButtonText={"Cancel"}
                  submitButtonText={"Submit"}
                  resetButton={true}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default PasswordReset;
